export {OnlineDiscountBadge} from './OnlineDiscountBadge';
